/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

// 予約設定
export const rsvConfigSlice = createSlice({
  name: 'rsvConfig',
  initialState: {
    rsvMode: null,
    topicPath: [],
    maxAttendees: 0,
    rsvPlaceIds: [],
    rsvTelPlaceIds: [],
    telStart: 3,
    skipItemSelect: false,
    dispBusinessSelect: true,
    locationSetting: {},
  },
  reducers: {
    saveRsvMode: (state, action) => {
      state.rsvMode = action.payload.rsvMode;
    },
    saveTopicPath: (state, action) => {
      state.topicPath = action.payload.topicPath;
    },
    saveMaxAttendees: (state, action) => {
      state.maxAttendees = action.payload.maxAttendees;
    },
    saveConfig: (state, action) => {
      state.rsvMode = action.payload.rsvMode;
      state.topicPath = action.payload.topicPath;
      state.maxAttendees = action.payload.maxAttendees;
      state.rsvPlaceIds = action.payload.rsvPlaceIds;
      state.rsvTelPlaceIds = action.payload.rsvTelPlaceIds;
      state.telStart = action.payload.telStart;
      state.skipItemSelect = action.payload.skipItemSelect ?? false;
      state.dispBusinessSelect = action.payload.dispBusinessSelect ?? true;
      state.locationSetting = action.payload.locationSetting ?? state.locationSetting;
    },
    saveDispBusinessSelect: (state, action) => {
      state.dispBusinessSelect = action.payload.dispBusinessSelect;
    },
    saveLocationSetting: (state, action) => {
      state.locationSetting = action.payload.locationSetting ?? {};
    },
    clearConfig: (state) => {
      state.rsvMode = null;
      state.topicPath = [];
      state.maxAttendees = 0;
      state.rsvPlaceIds = [];
      state.rsvTelPlaceIds = [];
      state.telStart = 3;
      state.skipItemSelect = false;
      state.dispBusinessSelect = true;
      state.locationSetting = {};
    },
  },
});

export const { saveRsvMode, saveTopicPath, saveMaxAttendees, saveConfig, saveDispBusinessSelect, saveLocationSetting, clearConfig } =
  rsvConfigSlice.actions;
export const rsvConfigReducer = rsvConfigSlice.reducer;
